import { render, staticRenderFns } from "./FiftyFifty.vue?vue&type=template&id=d18bd144"
import script from "./FiftyFifty.vue?vue&type=script&lang=js"
export * from "./FiftyFifty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports